import { datadogRum } from '@datadog/browser-rum';

export namespace Log {
  export const d = message => {
    if (
      process.env.NODE_ENV === 'development' ||
      window.location.host === 'hotel-web.clevertravel.io'
    )
      console.log(message);
  };

  export const e = error => {
    if (
      process.env.NODE_ENV === 'development' ||
      window.location.host === 'hotel-web.clevertravel.io'
    )
      console.error(error);
  };

  export const onImageError = (imageUrl, href) => {
    datadogRum.addError(new Error('IMAGE_ERROR'), {
      args: {
        location: href,
        imageUrl: imageUrl,
      },
    });
  };

  export const onAuthError = (originalRequest, logs, error) => {
    datadogRum.addError(new Error(error), {
      request: JSON.stringify(originalRequest),
      history: logs,
    });
  };

  export const onLocalStorageCleared = () => {
    datadogRum.addError(
      new Error('locale storage synced on logout for tabs and cleared'),
    );
  };

  export const onBadRequst = (request, status, args) => {
    datadogRum.addError(
      new Error('BAD_REQUEST'), {
        request: JSON.stringify(request),
        status,
        args
      }
    );
  };
}
